import axios from 'axios';

const instance = axios.create({
	baseURL: import.meta.env.VITE_APP_API_URL,
	headers: {
		'Content-Type': 'application/json'

		// Add any common headers here
	}
});
export const getTrailerData = async trailerId => {
	try {
		const response = await instance.post(`/vimeo/trailer/details`, {
			trailerId
		});
		return response?.data;
	} catch (err) {
		throw err;
	}
};
